import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import { configure } from 'vue-gtag'
import { createRouterInstance } from './router'
import BaseImage from './components/BaseImage.vue'
import CardWithIcon from './components/CardWithIcon.vue'
import { createUnhead } from '@unhead/vue' // This import, with createUnhead, seems necessary for SSG - it is not in official docs. DO NOT CHANGE TO SERVER or CLIENT.


configure({
  tagId: 'G-DV8RDNT7DS'
})

const router = createRouterInstance(true)
const head = createUnhead()

export const createApp = ViteSSG(
  App,
  { routes: router.options.routes },
  ({ app, router: ssgRouter, isClient }) => {
    // Scroll to top on navigation
    ssgRouter.options.scrollBehavior = () => ({ top: 0 })

    // Register global components
    app.component('BaseImage', BaseImage)
    app.component('CardWithIcon', CardWithIcon)

    // Use head manager
    app.use(head)
  
  }
)